/**
 * COPIED from pages/dev-agent/components/metadataEditor/monacoLanguage.ts (no store coupling).
 * Monaco language id from file name + Salesforce metadata type.
 */
export const MIN_EDITOR_WIDTH = 450;
export const MAX_EDITOR_WIDTH = 900;

export function getMonacoLanguage(fileName: string, metadataType?: string): string {
  const parts = fileName.split(".");
  const ext = parts.length > 1 ? parts.pop()?.toLowerCase() : undefined;
  const EXT_MAP: Record<string, string> = {
    cls: "apex",
    trigger: "apex",
    xml: "xml",
    html: "html",
    cmp: "html",
    page: "html",
    component: "html",
    js: "javascript",
    ts: "typescript",
    css: "css",
    json: "json",
    /*
     * ── Added for blocks opened FROM THE CONVERSATION ─────────────────────────
     *
     * A fenced block in an answer can be any of these, and the tab's language is derived from its
     * label's extension (below). Without them a YAML block fell through to the `"apex"` default at
     * the bottom of this function and was tokenised as Apex — a wrong tokenizer, which is worse
     * than none. `txt` is the honest landing place for an UNTAGGED fence: plaintext claims nothing.
     *
     * Only additions: the ext → metadataType → apex ORDER is unchanged, so a Flow with no
     * extension still resolves through its metadata type exactly as before.
     */
    yaml: "yaml",
    yml: "yaml",
    sql: "sql",
    py: "python",
    rb: "ruby",
    go: "go",
    rs: "rust",
    java: "java",
    md: "markdown",
    sh: "shell",
    bash: "shell",
    diff: "diff",
    patch: "diff",
    txt: "plaintext",
  };
  if (ext && EXT_MAP[ext]) return EXT_MAP[ext];

  if (metadataType) {
    const mt = metadataType.toLowerCase();
    if (mt.includes("apex") || mt === "apexclass" || mt === "apextrigger") return "apex";
    if (mt.includes("lightning") || mt.includes("lwc") || mt.includes("aura")) return "javascript";
    if (mt.includes("visualforce") || mt === "apexpage" || mt === "apexcomponent") return "html";
    if (mt.includes("custom") || mt.includes("flow") || mt.includes("flexi")) return "xml";
  }

  return "apex";
}
